import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/auth";
import { Form, LoginContainer, StyledBox } from "./Login.styled";
import {Checkbox, FormControlLabel, TextField, Typography, useTheme} from "@mui/material";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import LoginIcon from "@mui/icons-material/Login";
import axios from "axios";

export function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const theme = useTheme();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await login(username, password);
      navigate("/pairs");
      window.location.reload();
    } catch (requestError) {
      if (axios.isAxiosError(requestError) && requestError.response?.status === 401) {
        setError("Invalid email or password");
      } else if (axios.isAxiosError(requestError) && !requestError.response) {
        setError("Cannot connect to the server. Check your internet connection.");
      } else {
        setError("Sign in failed. Please try again.");
      }
    }
  }

  return (
      <ThemeProvider theme={theme}>
        <StyledBox>
          <LoginContainer>
            <Typography variant="h5" align="center" gutterBottom>
              Sign In Lukky
            </Typography>
            <Typography variant="body2" align="center" gutterBottom sx={{ mb: 2 }}>
              Welcome user, please sign in to continue
            </Typography>
            {error && <Typography color="error">{error}</Typography>}
            <Form onSubmit={handleSubmit}>
              <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  inputProps={{ style: { fontSize: 16 } }}
              />
              <TextField
                  label="Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  inputProps={{ style: { fontSize: 16 } }}
              />
              <FormControlLabel control={<Checkbox />} label="Remember Me" />
              <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#90caf9", color: "#000" }} endIcon={<LoginIcon />}>
                Sign In
              </Button>
            </Form>
          </LoginContainer>
        </StyledBox>
      </ThemeProvider>
  );
}
